module.exports = "//static.hsappstatic.net/commerce-tools-ui-lib/static-1.2844/images/payment_methods.png"